// Phase 1 — Account menu (avatar + Log out).
//
// Logout logic is reproduced verbatim from the legacy apparelMenu.tsx:
//   setAuthToken("") ; setUser("") ; navigate("/login").
// No auth/session logic is changed — only the chrome that triggers it.
import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { getUser, setAuthToken, setUser } from "../Utils/localStorage";
import { Avatar, AvatarFallback } from "ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "ui/dropdown-menu";
import { cn } from "lib/utils";

// Same initials logic as legacy defaultThumbnail() in apparelMenu.tsx.
function initials(user: any): string {
  try {
    let name = "";
    name += user?.firstName ? user.firstName[0].toUpperCase() : "";
    name += user?.lastName ? user.lastName[0].toUpperCase() : "";
    return name || "U";
  } catch (ex) {
    return "U";
  }
}

export function AccountMenu({ showName = false, align = "end" }: { showName?: boolean; align?: "start" | "end" }) {
  const navigate = useNavigate();
  const user: any = getUser();
  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(" ") || "User";

  const clearUserDetailsAndToken = () => {
    setAuthToken("");
    setUser("");
    navigate("/login");
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={cn(
            "mz flex items-center gap-2 rounded-lg p-1 text-left outline-none transition-colors hover:bg-muted focus-visible:ring-2 focus-visible:ring-ring",
            showName && "w-full pr-2"
          )}
        >
          <Avatar className="h-8 w-8">
            <AvatarFallback className="text-xs">{initials(user)}</AvatarFallback>
          </Avatar>
          {showName && (
            <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground">{fullName}</span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="w-52">
        <DropdownMenuLabel className="truncate text-sm text-foreground">{fullName}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={clearUserDetailsAndToken}>
          <LogOut className="h-4 w-4" />
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
